<div *transloco="let t">
  <p-accordion class="accordion-dark" [multiple]="true" [value]="[]">
    <p-accordion-panel value="availableOffices">
      <p-accordion-header>
        <h2 class="text-lg font-semibold m-0" data-testid="offices-header">
          {{ t('project.detail.availableOffices') }}
          <span class="ml-2 text-sm text-gray-400" data-testid="offices-count">
            {{ offices().length }} {{ t('common.office') }}
          </span>
        </h2>
      </p-accordion-header>
      <p-accordion-content>
        <p-table [value]="offices()" [loading]="loading()" data-testid="project-office-table">
          <ng-template #header>
            <tr>
              <th scope="col">{{ t('common.companyName') }}</th>
              <th scope="col">{{ t('common.country') }}</th>
              <th scope="col">{{ t('common.city') }}</th>
              <th scope="col">{{ t('common.office') }}</th>
              <th scope="col" class="w-40 text-center"></th>
            </tr>
          </ng-template>
          <ng-template #body let-office>
            <tr>
              <td>{{ office.companyName }}</td>
              <td>
                <span class="fi fi-{{ office.countryCode | lowercase }} text-xl!"></span>
                {{ countryService.getCountryNameByCode(office.countryCode) }}
              </td>
              <td>{{ office.cityName }}</td>
              <td>{{ office.officeName }}</td>
              <td class="text-center">
                <p-button
                  [label]="t('common.functions')"
                  icon="pi pi-list"
                  severity="secondary"
                  (onClick)="selectFunctions(office)"
                ></p-button>
              </td>
            </tr>
          </ng-template>
          <ng-template #emptymessage>
            <tr>
              <td [attr.colspan]="5"><app-no-data /></td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordion-content>
    </p-accordion-panel>
    <p-accordion-panel value="functions">
      <p-accordion-header>
        <h2 class="text-lg font-semibold m-0" data-testid="functions-header">
          {{ t('common.functions') }}
        </h2>
      </p-accordion-header>
      <p-accordion-content>
        @for (group of contractFunctionGroups(); track group.moduleId) {
          <div class="mb-5">
            <h3 class="text-base font-semibold mb-2">{{ group.moduleName }}</h3>
            <div class="flex flex-wrap gap-2">
              @for (fn of group.functions; track fn.functionId) {
                <span
                  class="px-3 py-1 rounded-full text-sm border"
                  [ngClass]="
                    fn.selectedOfficeCount > 0
                      ? 'bg-green-800/30 text-green-300 border-green-600'
                      : 'bg-gray-700/30 text-gray-300 border-gray-500'
                  "
                >
                  {{ fn.functionName }}
                </span>
              }
            </div>
          </div>
        } @empty {
          <app-no-data />
        }

        <div class="mt-4 pt-3 border-t border-slate-700 flex flex-wrap items-center gap-6 text-sm">
          <div class="flex items-center gap-2">
            <div class="w-3 h-3 rounded-xs bg-gray-500"></div>
            <span class="text-gray-400">{{ t('project.detail.functionsLegend.notSelected') }}</span>
          </div>
          <div class="flex items-center gap-2">
            <div class="w-3 h-3 rounded-xs bg-green-500"></div>
            <span class="text-gray-400">{{ t('project.detail.functionsLegend.selected') }}</span>
          </div>
        </div>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>

  <app-function-selection-dialog
    [visible]="dialogVisible()"
    [label]="dialogOfficeName()"
    [initialSelectedFunctions]="dialogInitialSelectedFunctions()"
    [restrictToAvailableFunctions]="true"
    [readOnly]="dialogReadOnly()"
    [minSelections]="1"
    [translationPrefix]="dialogTranslationPrefix"
    (visibleChange)="$event ? null : closeDialog()"
    (selectedFunctions)="onFunctionsSelected($event)"
  ></app-function-selection-dialog>
</div>
